import { graphql } from "../gql";

export const getBatchClaimCommentsQueryDoc = graphql(`
  query getBatchClaimComments($claimId: UUID!) {
    batchClaim(id: $claimId) {
      id
      icn
      comments {
        id
        body
        authorId
        authorName
        createdAt
      }
    }
  }
`);
